function runModalLogic() {
  // Only run if the Skio subscription interval header is present
  if (!document.querySelector('[data-skio-name="subscription-header-interval"]')) return;

  // Pull the subscription ID from the URL and populate #subId
  const subId = window.location.pathname.split('/').pop();
  const subIdField = document.getElementById('subId');
  if (subIdField && subId) {
    subIdField.value = subId;
  }

  const modalKey = 'modalShown_' + window.customerId;

  // Only show once per customer
  if (localStorage.getItem(modalKey)) return;

  const overlay = document.getElementById('modal-overlay');
  if (!overlay) return;

  // Close on background click
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) {
      overlay.style.display = 'none';
    }
  });

  // Open if tag is present
  if (window.customerTags && window.customerTags.includes('frankly')) {
    overlay.style.display = 'flex';
    localStorage.setItem(modalKey, 'true');
  }
}

// Watch for Skio's AJAX content being injected into the DOM
const observer = new MutationObserver(function(mutations) {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1) {
        // Check if the added node is or contains our target element
        if (
          node.matches('[data-skio-name="subscription-header-interval"]') ||
          node.querySelector('[data-skio-name="subscription-header-interval"]')
        ) {
          runModalLogic();
          return;
        }
      }
    }
  }
});

// Start observing the whole body for any DOM changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Also run on initial load in case the element is already there
document.addEventListener('DOMContentLoaded', runModalLogic);